import InvestorRegistration from './InvestorRegistration';

export default InvestorRegistration;
